module.exports = __webpack_public_path__ + "static/shubhie-d3212f3ade4f0641877bea2256e7cdef.jpg";